import './Modal.scss';

import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';

import { MODAL_STYLE_RESET } from 'utils/constants';

import Button from 'components/Button';
import H3 from 'components/H3';
import Icon from 'components/Icon';

class Modal extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        closeModal: PropTypes.func,
        contentLabel: PropTypes.string,
        show: PropTypes.bool.isRequired,
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ])
    };

    render() {
        return (
            <ReactModal className={this.props.className}
                        contentLabel={this.props.contentLabel || 'Modal'}
                        isOpen={this.props.show === true}
                        style={MODAL_STYLE_RESET}>
                {this.props.closeModal != null ? (
                    <Button className="c-modal__close-button"
                            noStyles
                            onClick={this.props.closeModal.bind(this)}>
                        <Icon type="x"/>
                    </Button>
                ) : null}
                {this.props.title != null ? (
                    <H3>
                        {this.props.title}
                    </H3>
                ) : null}
                {this.props.children}
            </ReactModal>
        );
    }
}

ReactModal.setAppElement('#root');

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js